/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class ChannelFunc extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default ChannelFunc;


// WEBPACK FOOTER //
// ./src/routes/channelFunc/index.js